var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 201,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#step-3_svg__clip0_3334_11040)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.043 1H9.957C5.01 1 1 4.427 1 8.655v184.689C1 197.573 5.01 201 9.957 201h216.086c4.947 0 8.957-3.427 8.957-7.656V8.655C235 4.427 230.99 1 226.043 1z",
    fill: "#fff",
    stroke: "#E6EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.01 1H9.99C5.025 1 1 4.411 1 8.619v184.762C1 197.589 5.025 201 9.99 201h218.02c4.965 0 8.99-3.411 8.99-7.619V8.619C237 4.411 232.975 1 228.01 1z",
    fill: "url(#step-3_svg__paint0_linear_3334_11040)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.827 125.199h-.73a2.697 2.697 0 00-2.697 2.697v23.063a2.697 2.697 0 002.697 2.697h.73a2.697 2.697 0 002.697-2.697v-23.063a2.697 2.697 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint1_linear_3334_11040)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.638 125.199h-.729a2.697 2.697 0 00-2.697 2.697v23.063a2.696 2.696 0 002.697 2.697h.729a2.697 2.697 0 002.698-2.697v-23.063a2.698 2.698 0 00-2.698-2.697z",
    fill: "url(#step-3_svg__paint2_linear_3334_11040)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.03 125.199h-.729a2.697 2.697 0 00-2.697 2.697v14.932a2.697 2.697 0 002.697 2.698h.729a2.697 2.697 0 002.697-2.698v-14.932a2.697 2.697 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint3_linear_3334_11040)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.231 125.199h-.729a2.697 2.697 0 00-2.697 2.697v14.932a2.697 2.697 0 002.697 2.698h.729a2.697 2.697 0 002.697-2.698v-14.932a2.697 2.697 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint4_linear_3334_11040)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.434 125.199h-.729a2.697 2.697 0 00-2.697 2.697v14.932a2.697 2.697 0 002.697 2.698h.729a2.697 2.697 0 002.697-2.698v-14.932a2.697 2.697 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint5_linear_3334_11040)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.03 147.559h-.729a2.696 2.696 0 00-2.697 2.697v.703a2.696 2.696 0 002.697 2.697h.729a2.696 2.696 0 002.697-2.697v-.703a2.696 2.696 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint6_linear_3334_11040)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.231 147.559h-.729a2.696 2.696 0 00-2.697 2.697v.703a2.696 2.696 0 002.697 2.697h.729a2.696 2.696 0 002.697-2.697v-.703a2.696 2.696 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint7_linear_3334_11040)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.434 147.559h-.729a2.696 2.696 0 00-2.697 2.697v.703a2.696 2.696 0 002.697 2.697h.729a2.696 2.696 0 002.697-2.697v-.703a2.696 2.696 0 00-2.697-2.697z",
    fill: "url(#step-3_svg__paint8_linear_3334_11040)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.915 66.305H37.086a3.371 3.371 0 100 6.742h161.829a3.371 3.371 0 000-6.742z",
    fill: "url(#step-3_svg__paint9_linear_3334_11040)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.915 163.41H37.086a3.372 3.372 0 000 6.743h161.829a3.37 3.37 0 100-6.743z",
    fill: "url(#step-3_svg__paint10_linear_3334_11040)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.552 82.04H49.448a3.371 3.371 0 100 6.742h137.104a3.372 3.372 0 100-6.743z",
    fill: "url(#step-3_svg__paint11_linear_3334_11040)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "step-3_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 13,
    width: 45,
    height: 45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.648 13.486h43.829v43.829H96.648V13.486z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#step-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.59 14h-29.08v7.217h2.718v30.997a5.09 5.09 0 005.093 5.086h19.928a4.736 4.736 0 004.736-4.736V17.391c0-1.873-1.52-3.391-3.395-3.391z",
    fill: "url(#step-3_svg__paint12_linear_3334_11040)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.531,
    y: 49.182,
    width: 17.14,
    height: 1.804,
    rx: 0.902,
    fill: "#B6C7D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.531,
    y: 43.77,
    width: 17.14,
    height: 1.804,
    rx: 0.902,
    fill: "#B6C7D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.565 14a3.652 3.652 0 013.652 3.652v3.565H97v-3.75C97 15.553 98.596 14 100.565 14z",
    fill: "url(#step-3_svg__paint13_linear_3334_11040)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.251,
    filter: "url(#step-3_svg__filter0_f_3334_11040)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.923,
    cy: 48.279,
    fill: "#6F6F6F",
    r: 9.021
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 106.021,
    cy: 48.279,
    r: 9.021,
    fill: "url(#step-3_svg__paint14_linear_3334_11040)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#step-3_svg__filter1_d_3334_11040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.271 45.803a.705.705 0 011.044 0 .83.83 0 01.061 1.042l-.061.075-4.428 4.736a.704.704 0 01-.975.065l-.069-.065-2.214-2.368a.827.827 0 010-1.117.703.703 0 01.974-.065l.069.065 1.693 1.81 3.906-4.178z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 118.65,
    cy: 30.237,
    r: 9.923,
    fill: "url(#step-3_svg__paint15_linear_3334_11040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.356 24.824a.902.902 0 01.105 1.798l-.105.006h-3.383a1.128 1.128 0 00-.115 2.25l.115.006h1.354a2.931 2.931 0 01.166 5.858l-.166.005h-3.383a.902.902 0 01-.105-1.798l.105-.006h3.383a1.128 1.128 0 00.115-2.25l-.115-.005h-1.354a2.931 2.931 0 01-.166-5.86l.166-.004h3.383z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.542 23.021c.462 0 .844.349.896.797l.006.106v1.804a.902.902 0 01-1.798.105l-.006-.105v-1.804c0-.499.404-.902.902-.902zM118.542 32.943c.462 0 .844.349.896.797l.006.105v1.805a.902.902 0 01-1.798.105l-.006-.105v-1.805c0-.498.404-.902.902-.902z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint0_linear_3334_11040",
    x1: 119,
    y1: 201,
    x2: 119,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE7F2",
    stopOpacity: 0.795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint1_linear_3334_11040",
    x1: 97.604,
    y1: 125.199,
    x2: 89.042,
    y2: 153.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint2_linear_3334_11040",
    x1: 138.415,
    y1: 125.199,
    x2: 129.853,
    y2: 153.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint3_linear_3334_11040",
    x1: 107.943,
    y1: 125.199,
    x2: 99.933,
    y2: 143.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint4_linear_3334_11040",
    x1: 118.144,
    y1: 125.199,
    x2: 110.134,
    y2: 143.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint5_linear_3334_11040",
    x1: 128.347,
    y1: 125.199,
    x2: 120.337,
    y2: 143.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint6_linear_3334_11040",
    x1: 110.727,
    y1: 147.584,
    x2: 101.43,
    y2: 154.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint7_linear_3334_11040",
    x1: 120.928,
    y1: 147.584,
    x2: 111.631,
    y2: 154.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint8_linear_3334_11040",
    x1: 131.131,
    y1: 147.584,
    x2: 121.834,
    y2: 154.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint9_linear_3334_11040",
    x1: 202.286,
    y1: 66.305,
    x2: 33.715,
    y2: 66.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint10_linear_3334_11040",
    x1: 202.286,
    y1: 163.41,
    x2: 33.715,
    y2: 163.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint11_linear_3334_11040",
    x1: 189.924,
    y1: 82.039,
    x2: 46.076,
    y2: 82.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint12_linear_3334_11040",
    x1: 133.985,
    y1: 57.3,
    x2: 133.985,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EEF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint13_linear_3334_11040",
    x1: 97,
    y1: 21.217,
    x2: 104.217,
    y2: 21.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint14_linear_3334_11040",
    x1: 97,
    y1: 39.258,
    x2: 97,
    y2: 57.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D672"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step-3_svg__paint15_linear_3334_11040",
    x1: 108.727,
    y1: 20.314,
    x2: 108.727,
    y2: 40.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEDAE6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "step-3_svg__filter0_f_3334_11040",
    x: 95.184,
    y: 36.539,
    width: 23.478,
    height: 23.478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur_3334_11040"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "step-3_svg__filter1_d_3334_11040",
    x: 100.412,
    y: 43.572,
    width: 12.119,
    height: 10.315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.000815457 0 0 0 0 0.563094 0 0 0 0 0.402443 0 0 0 0.272946 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3334_11040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3334_11040",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "step-3_svg__clip0_3334_11040"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h236v201H0z"
  })))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/step-3-5cdecc48c48c57b83c794970a58d6a19.svg";
export { SvgStep3 as ReactComponent };